import React, { Fragment, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import {
    Badge,
    Button, Card, CardBody, DropdownMenu, DropdownToggle, Input, DropdownItem, Modal,
    ModalBody, ModalFooter, ModalHeader, Row, UncontrolledDropdown
} from "reactstrap";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import { AxiosAPI, getGroupID, getUserID } from "../../../../../helpers/AxiosAPI";
import { connect } from 'react-redux';
import { API_Logs } from "../../../../../constants/APIs";
import moment from "moment";
import Pagination from "../../../../../containers/pages/Pagination";

function generateRandomColor() {
    var arr = [
        'primary',
        'secondary',
        'info',
        'success',
        'warning',
        'danger',
        'light',
        'dark',
    ];
    return arr[Math.floor(Math.random() * arr.length)];
}

function Logs({ logType, visible, label, toggle, propertyId, locale }) {
    const [logList, setLogList] = useState([]);
    const [pageSizes, setpageSizes] = useState([10, 15, 20, 25]);
    const [currentPage, setcurrentPage] = useState(1);
    const [SelectedPageSize, setSelectedPageSize] = useState(10);
    const startIndex = (currentPage - 1) * SelectedPageSize;
    const endIndex = currentPage * SelectedPageSize;
    const [TotalItems, setTotalItems] = useState(0);
    const [TotalPages, setTotalPages] = useState(1);

    const changePageSize = (size) => {
        setSelectedPageSize(size);
        setcurrentPage(1);
    };

    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${API_Logs}?groupId=${getGroupID()}&propertyId=${propertyId}&type=${logType}&pageNumber=${currentPage}&pageSize=${SelectedPageSize}`,
        }).then((res) => {
            setTotalItems(res.data.totalItems);
            setTotalPages(res.data.totalPages);
            setLogList(res.data.logs);
        });
    }, [getUserID(), currentPage, SelectedPageSize]);

    const onChangePage = (page) => {
        setcurrentPage(page);
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={toggle}>
                    {label}
                </ModalHeader>
                <ModalBody>
                    <Row className="logs">

                        <Colxx xxs="12">
                            <div className="float-md-right">
                                <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
                                <UncontrolledDropdown className="d-inline-block">
                                    <DropdownToggle caret color="outline-dark" size="xs">
                                        {SelectedPageSize}
                                    </DropdownToggle>
                                    <DropdownMenu right>
                                        {pageSizes.map((size, index) => {
                                            return (
                                                <DropdownItem
                                                    key={index}
                                                    onClick={() => changePageSize(size)}
                                                >
                                                    {size}
                                                </DropdownItem>
                                            );
                                        })}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                        </Colxx>
                        <Colxx xxs="12">
                            {(logList !== undefined && logList.length > 0) && logList.map((m, index) =>
                                <Row className="mb-3">
                                    <Colxx xxs="12" xs="3">
                                        <Fragment>
                                            Version On:<br />
                                            {moment(m.date).format(
                                                'MMM DD, YYYY h:mm a'
                                            )}<br /><br />
                                            {m.action !== undefined &&
                                                <Fragment>
                                                    Action:<br />
                                                    <span style={{ color: `${m.action.includes('Delete') ? 'red' : 'green'}` }} >{m.action}</span>
                                                </Fragment>
                                            }
                                        </Fragment>
                                    </Colxx>
                                    <Colxx xxs="12" xs="9">
                                        <Card className="d-flex mb-3" key={`faqItem_${index}`} style={{ borderRadius: '25px' }}>
                                            <CardBody className="logsBody" style={{ overflowX: 'scroll' }}>
                                                <Row className="mb-2">
                                                    <Colxx xxs="12" className='mb-2'>
                                                        <b>Title: </b>
                                                        {m.content.Title}
                                                    </Colxx>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Colxx xxs="12" className='mb-2'>
                                                        <b>Status: </b>
                                                        {m.content.Status === 'Archieve' ? <span color='red'>{m.content.Status}</span> :
                                                            <span color='green'>{m.content.Status}</span>}
                                                    </Colxx>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Colxx xxs="12" className='mb-2'>
                                                        <b>Document Link</b>
                                                    </Colxx>
                                                    <Colxx xxs="12" className="ml-0">
                                                        {m.content.Link}
                                                    </Colxx>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Colxx xxs="12" className='mb-2'>
                                                        <b>Tags</b>
                                                    </Colxx>
                                                    <Colxx xxs="12" className="ml-0">
                                                        {(m.content.Tags !== undefined && m.content.Tags.length > 0) && m.content.Tags.map((m, i) =>
                                                            <Badge
                                                                color={generateRandomColor(i)} className="mt-1 mr-1">
                                                                {m}
                                                            </Badge>
                                                        )
                                                        }
                                                    </Colxx>
                                                </Row>
                                                {(m.comments !== undefined && m.comments !== null && m.comments !== '') && <Row className="">
                                                    <Colxx xxs="12" className='mb-2'>
                                                        <b>Comments</b>
                                                    </Colxx>
                                                    <Colxx xxs="12" className="ml-0">
                                                        {m.comments}
                                                    </Colxx>
                                                </Row>}
                                            </CardBody>
                                        </Card>
                                    </Colxx>
                                </Row>)}
                        </Colxx>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Pagination
                        currentPage={currentPage}
                        totalPage={TotalPages}
                        onChangePage={(i) => onChangePage(i)}
                    />
                    <Button color='secondary' onClick={toggle}>Back</Button>
                </ModalFooter>
            </Modal>
        </Fragment >
    )
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId,
        locale,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Logs));